export default function init() {
    document.addEventListener('DOMContentLoaded', () => {
        const overlayCookieName = 'overlayShown'
        const overlayCookieExpirationTime = 24

        // Cookie logic
        function setCookie(name, value, hours) {
            const expires = new Date(Date.now() + (hours * 3600e3)).toUTCString()
            // eslint-disable-next-line unicorn/no-document-cookie
            document.cookie = `${name}=${value}; expires=${expires}; path=/`
        }

        function getCookie(name) {
            const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
            return match ? match[1] : undefined
        }

        if (getCookie(overlayCookieName)) {
            return
        }

        // Overlay logic
        const overlay = document.querySelector('#renaming-overlay')
        const closeButton = overlay.querySelector('.overlay--close')
        let popupShown = false

        function showPopup() {
            if (popupShown) {
                return
            }

            popupShown = true
            overlay.classList.add('is-open')
        }

        // Hide popup and set cookie
        function hidePopup() {
            setCookie(overlayCookieName, '1', overlayCookieExpirationTime)
            document.documentElement.classList.remove('block-scroll')
            overlay.classList.remove('is-open')
            // Restore main content interactivity and accessibility
            document.body.querySelectorAll('[inert]').forEach(element => {
                element.removeAttribute('inert')
            })
            document.querySelector('.skip-link').removeAttribute('inert')
        }

        // Close when clicking the close button
        closeButton.addEventListener('click', hidePopup)

        // Close on Enter or Spacebar key
        closeButton.addEventListener('keydown', element => {
            if (element.key === 'Enter' || element.key === ' ') {
                element.preventDefault()
                hidePopup()
            }
        })

        // Close on Escape key
        window.addEventListener('keydown', element => {
            if (element.key === 'Escape' && overlay.classList.contains('is-open')) {
                hidePopup()
            }
        })

        // Also close when Enter or Space is pressed while focused on the close button
        closeButton.addEventListener('keydown', element => {
            if (element.key === 'Enter' || element.key === ' ') {
                element.preventDefault()
                hidePopup()
            }
        })

        // Close on Escape key
        document.addEventListener('keydown', element => {
            if (element.key === 'Escape' && overlay.style.display === 'flex') {
                hidePopup()
            }
        })

        // Close when clicking outside the popup
        overlay.addEventListener('click', element => {
            if (element.target === overlay) {
                hidePopup()
            }
        })

        showPopup()
    })
}
